import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down-left"} maskId="square-filled-radius-0-stroke-1-IconArrowDownLeft"><path fillRule="evenodd" clipRule="evenodd" d="M19.1642 6.25003L8.41421 17H16V19H5V8.00003H7V15.5858L17.75 4.83582L19.1642 6.25003Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDownLeft;
